import React, { useContext, useEffect, useState } from "react";
import "./Checkout.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Payment_Summary from "../profile/right_side_content/inner_details_pages/order_details/payment_summary/Payment_Summary";
import Select_payment from "./select-payment/Select_payment";
import Place_order from "./place-order-box/Place_order";
import {
  getAllOrderAddress,
  OrderCalculation,
} from "../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/IDS";
import { myAccount } from "../../features/my_account/Slice";

const Checkout = ({
  orderAddress,
  setOrderAddress,
  deliveryNote,
  setDeliveryNote,
}) => {
  const dispatch = useDispatch();
  const { signin } = useContext(Context);
  const [CouponData, setCouponData] = useState();
  const [paymentData, setPaymentData] = useState({});

  const breadcrumbs = [
    { label: "SHOP", link: "/explore-latest-products", active: false },
    { label: "CART", link: "/cart", active: false },
    { label: "CHECKOUT", link: "", active: true },
  ];

  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  const [paymentValue, setPaymentValue] = useState(IDS.Payment_Methods.Cash);
  const user = useSelector((state) => state.myaccount.addMyaccount);


  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);
  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);

  // Pick first address after API loads
  const address = allAddress?.data?.[0];

  useEffect(() => {
    if (address && !orderAddress?.id) {
      setOrderAddress(address);
    }
  }, [address, orderAddress, setOrderAddress]);

  const orderCalculation = async (addressId) => {
    const fallbackAddressId =
      Array.isArray(allAddress?.data) && allAddress?.data.length > 0
        ? allAddress.data[0].id
        : null;

    const data = {
      address_id: addressId || fallbackAddressId,
    };

    if (CouponData) {
      data.coupon_id = CouponData.id;
    }

    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setPaymentData(res?.payload?.data);
    } else if (res.meta?.requestStatus === "rejected") {
      // handle error
    }
  };

  useEffect(() => {
    if (orderAddress?.id) {
      orderCalculation(orderAddress?.id);
    }
  }, [orderAddress?.id, CouponData]);

  return (
    <>
      <section className="container">
        <div className="container">
          <Breadcrumb_Comp data={breadcrumbs} />

          <div className="row">
            <div className="col-lg-8 mb-lg-0 mb-4 p-lg-auto p-0">
              <Select_payment
                walletAmount={user?.Wallet?.amount}
                orderAddress={orderAddress}
                paymentValue={paymentValue}
                setPaymentValue={setPaymentValue}
              />
            </div>
            <div className="col-lg-4 p-lg-auto p-0 ">
              <Payment_Summary
                isCheckoutPage={true}
                data={paymentData?.order_summary}
              />

              <Place_order
                setDeliveryNote={setDeliveryNote}
                CouponData={CouponData}
                setCouponData={setCouponData}
                deliveryNote={deliveryNote}
                paymentData={paymentData}
                isSignIn={signin}
                orderAddress={orderAddress}
                paymentValue={paymentValue}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Checkout;
